import React from 'react';

import { useDrawer } from '@common/drawers/dynamicProvider.drawer';
import EnhancedButton from '@components/button/EnhancedButton';
import DatePickerFormField from '@components/form-fields/DatePickerFormField';
import TextInputFormField from '@components/form-fields/TextInputFormField';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import FormattingService from '@core/services/FormattingService';

import { IAmendmentDetails } from '../types';

type Props = {
  amendmentId: string;
  amendmentDetails: IAmendmentDetails;
  status: 'NEW' | 'IN_PROGRESS' | 'CONFIRMED' | 'CANCELLED' | string;
  systemReferenceDate: string;
  policyEffectiveDate: string;
  policyExpiryDate: string;
};

export const AmendmentCancellationDetailsAtom: React.FC<Props> = ({
  amendmentId,
  amendmentDetails,
  status,
  policyEffectiveDate,
  policyExpiryDate
}) => {
  const { openDrawer } = useDrawer();

  const isLocked = status === 'CONFIRMED' || status === 'CANCELLED';
  const handleModifyClick = () => {
    const amendmentData = {
      amendmentID: amendmentId,
      amendmentReason: amendmentDetails.amendmentReason || '',
      amendmentEffectiveDate: amendmentDetails.amendmentEffectiveDate || '',
      amendmentIssueDate: amendmentDetails.amendmentIssueDate,
      originalEffectiveDate: amendmentDetails.amendmentEffectiveDate || '',
      policyEffectiveDate,
      policyExpiryDate
    };
    openDrawer('modifyAmendmentDetailsDrawer', 'Modify Amendment Details', {
      amendmentData
    });
  };

  return (
    <WidgetPaper>
      <WidgetSection
        actions={
          !isLocked && (
            <div>
              <EnhancedButton isPrimary onClick={handleModifyClick}>
                Modify
              </EnhancedButton>
            </div>
          )
        }
        title="Amendment Details"
        isFieldsGrid
        fieldsPerRow={2}
      >
        <TextInputFormField
          key="amendmentType"
          name="amendmentDetails.amendmentType"
          title="Amendment Type*"
          placeholder="Amendment Type"
          value={FormattingService.formatCamelCaseToDisplay(
            amendmentDetails.amendmentType
          )}
          disabled
          material
          onChange={() => {}}
        />
        <TextInputFormField
          key="amendmentReason"
          name="amendmentDetails.amendmentReason"
          title="Cancellation Reason*"
          placeholder="Cancellation Reason"
          value={amendmentDetails.amendmentReason}
          disabled
          material
          onChange={() => {}}
        />
      </WidgetSection>
      <WidgetSection isFieldsGrid fieldsPerRow={2}>
        <DatePickerFormField
          name="amendmentDetails.amendmentIssueDate"
          title="Amendment Issue Date*"
          placeholder="Amendment Issue Date"
          value={amendmentDetails.amendmentIssueDate}
          onDateChange={() => {}}
          disabled
          material
        />
        <DatePickerFormField
          name="amendmentDetails.amendmentEffectiveDate"
          title="Amendment Effective Date*"
          placeholder="Amendment Effective Date"
          value={amendmentDetails.amendmentEffectiveDate}
          onDateChange={() => {}}
          disabled
          material
        />
      </WidgetSection>
    </WidgetPaper>
  );
};
